import { useCallback, useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import services from '../../../../services';
import { SnackbarContext } from '../../../../state/SnackbarContextProvider';

export const useUploader = ({ onUpload }: { onUpload: (url: string) => void }) => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const { openSnackbar } = useContext(SnackbarContext);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	const uploadFile = useCallback(
		async (lernsetId: string, _file?: File) => {
			if (!_file) return;
			setLoading(true);
			try {
				const formData = new FormData();
				formData.append('image', _file);
				const { imageUrl } = await services.lernsets.uploadImage(lernsetId, formData);

				onUpload(imageUrl);
			} catch {
				openSnackbar({
					type: 'error',
					message: t('The image could not be uploaded. Please try again.'),
				});
			}
			setLoading(false);
		},
		[onUpload]
	);

	return { loading, uploadFile };
};

export const useFileUpload = () => {
	const fileInput = useRef<HTMLInputElement>(null);

	const handleUploadClick = useCallback(() => {
		fileInput.current?.click();
	}, []);

	return { ref: fileInput, handleUploadClick };
};
